import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminUsersListHeader from './ListHeader';
import AdminUsersListItem from './ListItem';
import AdminUsersListItemLoading from './ListItemLoading';

const AdminUsersList = ({
  loading,
  users,
  selectedUsers,
  handleDeactivate,
  handleActivate,
  handleSelectUser,
  handleSendWelcomeEmails,
  ...props
}) => {
  const intl = useIntl();

  return (
    <div className="table-wrapper">
      <Table className="users-list" responsive>
        <thead>
          <AdminUsersListHeader
            users={users}
            selectedUsers={selectedUsers}
            handleSelectUser={handleSelectUser}
            {...props}
          />
        </thead>
        <tbody>
          {loading ? (
          /* eslint-disable react/no-array-index-key */
            [...Array(20)].map((_, i) => (
              <AdminUsersListItemLoading key={i} />
            ))
          ) : (
            users.map(user => (
              <AdminUsersListItem
                key={user.uuid}
                user={user}
                selectedUsers={selectedUsers}
                handleDeactivate={handleDeactivate}
                handleActivate={handleActivate}
                handleSelectUser={handleSelectUser}
                handleSendWelcomeEmails={handleSendWelcomeEmails}
              />
            )))}
        </tbody>
      </Table>
      {!loading && users.length === 0 && (
        <div className="nothing-found-wrapper nothing-found-table-wrapper">
          <h4>{intl.formatMessage({ defaultMessage: 'No users found' })}</h4>
        </div>
      )}
    </div>
  );
};

AdminUsersList.propTypes = {
  loading: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired,
  selectedUsers: PropTypes.array.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleDeactivate: PropTypes.func.isRequired,
  handleActivate: PropTypes.func.isRequired,
  handleSelectUser: PropTypes.func.isRequired,
  handleSendWelcomeEmails: PropTypes.func.isRequired,
};

export default AdminUsersList;
